"use client";

import { PageHeader, BreadcrumbSegment } from "./page-header";
import { PageTitle } from "components/page-title";
import { type LucideIcon } from "lucide-react";

interface StandardPageLayoutProps {
  breadcrumbs: BreadcrumbSegment[];
  overlay?: boolean;
  pageTitle?: {
    icon: LucideIcon;
    title: string;
    description: string;
    actions?: React.ReactNode;
  };
  sidebar?: React.ReactNode;
  children: React.ReactNode;
  showDemoToggle?: boolean;
  showModeToggle?: boolean;
  headerActions?: React.ReactNode;
  maxWidth?: "full" | "7xl" | "6xl";
}

export function StandardPageLayout({
  overlay,
  breadcrumbs,
  pageTitle,
  sidebar,
  children,
  showDemoToggle = true,
  showModeToggle = true,
  headerActions,
  maxWidth = "full",
}: StandardPageLayoutProps) {
  const maxWidthClass = {
    full: "",
    "7xl": "max-w-7xl mx-auto",
    "6xl": "max-w-6xl mx-auto",
  }[maxWidth];

  return (
    <>
      {overlay ? (
        <main className="relative flex-1 overflow-hidden">{children}</main>
      ) : (
        <main className="flex-1 min-w-0 overflow-auto">
          <div className={`px-6  pb-6 ${maxWidthClass}`}>
            {sidebar ? (
              <div className="grid gap-8 md:grid-cols-[220px_1fr]">
                <aside className="hidden md:block">
                  <div className="sticky top-0 space-y-6">{sidebar}</div>
                </aside>
                <div className="min-w-0  space-y-6">
                  {pageTitle && <PageTitle {...pageTitle} />}
                  {children}
                </div>
              </div>
            ) : (
              <div className="space-y-6 ">
                {pageTitle && <PageTitle {...pageTitle} />}
                {children}
              </div>
            )}
          </div>
        </main>
      )}
    </>
  );
}
